// 营销邮件管理 (FBMPLAY-1231) i18n — 6 个命名空间合并
export default {
  emailSenders: {
    tab: { senders: 'Ngưồi gửi' },
    title: 'Quản lý người gửi',
  
    // Biểu mẫu tìm kiếm
    form: {
      channelEmpty: 'Chưa có tên miền gửi nào, vui lòng thêm tại Tên miền gửi / Kênh',
      bussType: 'Loại nghiệp vụ',
      bussTypePlaceholder: 'Vui lòng chọn loại nghiệp vụ',
      channel: 'Kênh',
      channelPlaceholder: 'Vui lòng chọn kênh',
      fromEmail: 'Email người gửi',
      fromEmailPlaceholder: 'Vui lòng nhập email người gửi',
      fromEmailPrefixPlaceholder: 'Nhập phần trước @',
      domainPending: 'Vui lòng chọn tên miền gửi trước',
      fromName: 'Tên người gửi',
      fromNamePlaceholder: 'Vui lòng nhập From Name',
      status: 'Trạng thái',
      statusPlaceholder: 'Vui lòng chọn trạng thái'
    },
  
    // Cột bảng
    table: {
      index: 'STT',
      fromName: 'From Name',
      bussType: 'Loại nghiệp vụ',
      fromEmail: 'From Email',
      channel: 'Kênh',
      lastOperator: 'Người thao tác · Thời gian',
      status: 'Trạng thái',
      actions: 'Thao tác'
    },
  
    // Loại nghiệp vụ
    bussType: {
      marketing: 'Tiếp thị',
      notification: 'Thông báo'
    },
  
    // Kênh
    channel: {
      notConfigured: 'Chưa có tên miền',
      mailgunApi: 'Mailgun API'
    },
  
    // Trạng thái
    status: {
      enabled: 'Bật',
      disabled: 'Tắt'
    },
  
    // Nút
    button: {
      search: 'Tìm kiếm',
      reset: 'Đặt lại',
      create: 'Thêm mới',
      edit: 'Chỉnh sửa',
      delete: 'Xóa'
    },
  
    // Hộp thoại
    modal: {
      createTitle: 'Thêm người gửi',
      editTitle: 'Chỉnh sửa người gửi'
    },
  
    // Xác thực
    validation: {
      domainMismatch: 'Tên miền của From Email ({{emailDomain}}) không khớp với tên miền gửi đã chọn ({{channelDomain}})',
      domainNotConfigured: 'Tên miền {{domain}} chưa cấu hình kênh / key, vui lòng thêm tại Tên miền gửi / Kênh',
      bussTypeRequired: 'Vui lòng chọn loại nghiệp vụ',
      channelRequired: 'Vui lòng chọn kênh',
      fromEmailRequired: 'Vui lòng nhập email người gửi',
      fromEmailInvalid: 'Vui lòng nhập địa chỉ email hợp lệ',
      fromEmailPrefixRequired: 'Vui lòng nhập tiền tố hộp thư',
      fromEmailPrefixInvalid: 'Tiền tố chỉ được chứa chữ, số và các ký hiệu thông dụng như . _ - +',
      fromNameRequired: 'Vui lòng nhập From Name',
      statusRequired: 'Vui lòng chọn trạng thái'
    },
  
    // Xác nhận
    confirm: {
      enable: 'Bạn có chắc muốn bật người gửi này không?',
      disable: 'Bạn có chắc muốn tắt người gửi này không?',
      delete: 'Bạn có chắc muốn xóa người gửi này không?',
      okText: 'Đồng ý',
      cancelText: 'Hủy'
    },
  
    // Thông báo
    message: {
      queryFailed: 'Truy vấn thất bại',
      createSuccess: 'Tạo thành công',
      createFailed: 'Tạo thất bại',
      updateSuccess: 'Cập nhật thành công',
      updateFailed: 'Cập nhật thất bại',
      deleteSuccess: 'Xóa thành công',
      deleteFailed: 'Xóa thất bại',
      statusUpdateSuccess: 'Cập nhật trạng thái thành công',
      statusUpdateFailed: 'Cập nhật trạng thái thất bại'
    }
  },
  emailTemplates: {
    title: 'Mẫu Email',
  
    loadingMore: 'Đang tải...',
    copySuffix: '-Bản sao',
  
    // Form
    form: {
      tempName: 'Tên mẫu',
      tempNamePlaceholder: 'Vui lòng nhập tên mẫu',
      country: 'Khu vực',
      countryPlaceholder: 'Vui lòng chọn khu vực',
      category: 'Phân loại',
      categoryPlaceholder: 'Vui lòng chọn phân loại',
      bussType: 'Loại nghiệp vụ',
      bussTypePlaceholder: 'Vui lòng chọn loại nghiệp vụ',
      fromEmail: 'Người gửi',
      fromEmailPlaceholder: 'Vui lòng chọn người gửi',
      tempTitle: 'Tiêu đề email',
      tempTitlePlaceholder: 'Vui lòng nhập tiêu đề email',
      status: 'Trạng thái',
      statusPlaceholder: 'Vui lòng chọn trạng thái',
      content: 'Nội dung email',
      contentPlaceholder: 'Vui lòng nhập nội dung email (hỗ trợ HTML). Biến: {{memberAccount}}'
    },
  
    bussType: {
      marketing: 'Tiếp thị',
      notification: 'Thông báo'
    },
  
    table: {
      tempId: 'ID mẫu',
      tempName: 'Tên mẫu',
      bussType: 'Loại',
      country: 'Khu vực',
      category: 'Phân loại',
      tempTitle: 'Tiêu đề email',
      lastOperate: 'Người thao tác · Thời gian',
      status: 'Trạng thái',
      actions: 'Thao tác'
    },
  
    status: {
      enabled: 'Kích hoạt',
      disabled: 'Vô hiệu hóa'
    },
  
    button: {
      create: 'Mẫu mới',
      copy: 'Sao chép',
      test: 'Gửi thử'
    },
  
    modal: {
      createTitle: 'Tạo mẫu email',
      editTitle: 'Chỉnh sửa mẫu email'
    },
  
    variables: {
      example: 'Ví dụ',
      group: { COMMON: 'Chung', TRANSACTION: 'Giao dịch', ACTIVITY: 'Khuyến mãi' },
      title: 'Biến được hỗ trợ',
      tip: 'Nhấp vào biến để chèn vào nội dung email',
      memberAccount: 'Tài khoản thành viên'
    },
  
    validation: {
      tempNameRequired: 'Vui lòng nhập tên mẫu',
      countryRequired: 'Vui lòng chọn khu vực',
      categoryRequired: 'Vui lòng chọn phân loại',
      bussTypeRequired: 'Vui lòng chọn loại nghiệp vụ',
      fromEmailRequired: 'Vui lòng chọn người gửi',
      tempTitleRequired: 'Vui lòng nhập tiêu đề email',
      contentRequired: 'Vui lòng nhập nội dung email',
      statusRequired: 'Vui lòng chọn trạng thái'
    },
  
    message: {
      queryFailed: 'Truy vấn thất bại',
      createSuccess: 'Tạo thành công',
      createFailed: 'Tạo thất bại',
      updateSuccess: 'Cập nhật thành công',
      updateFailed: 'Cập nhật thất bại',
      deleteSuccess: 'Xóa thành công',
      deleteFailed: 'Xóa thất bại',
      copySuccess: 'Sao chép thành công',
      copyFailed: 'Sao chép thất bại',
      statusUpdateSuccess: 'Cập nhật trạng thái thành công',
      statusUpdateFailed: 'Cập nhật trạng thái thất bại'
    },
  
    confirm: {
      delete: 'Bạn có chắc chắn muốn xóa mẫu này không?',
      toggleStatus: 'Bạn có chắc chắn muốn thay đổi trạng thái của mẫu này không?'
    },
  
    pagination: {
      total: 'Tổng cộng {{total}} bản ghi'
    },
  
    test: {
      title: 'Gửi thử email',
      templateName: 'Tên mẫu',
      templateTitle: 'Tiêu đề email',
      templateContent: 'Nội dung email',
      inputLabel: 'Người nhận',
      inputPlaceholder: 'Vui lòng nhập địa chỉ email hoặc tài khoản thành viên',
      inputHint: 'Hệ thống sẽ tự động nhận diện địa chỉ email hay tài khoản thành viên',
      send: 'Gửi',
      inputRequired: 'Vui lòng nhập địa chỉ email hoặc tài khoản thành viên',
      success: 'Gửi thử thành công',
      failed: 'Gửi thử thất bại',
      error: 'Lỗi khi gửi thử',
      userNotFound: 'Người dùng thử nghiệm không có trong hệ thống'
    },
  
    category: {
      modal: {
        title: 'Quản lý phân loại mẫu'
      },
      table: {
        id: 'ID',
        name: 'Tên phân loại',
        actions: 'Thao tác'
      },
      form: {
        namePlaceholder: 'Vui lòng nhập tên phân loại'
      },
      button: {
        create: 'Phân loại mới'
      },
      confirm: {
        delete: 'Bạn có chắc chắn muốn xóa phân loại này không?',
        deleteDesc: 'Hành động này không thể hoàn tác, vui lòng thận trọng'
      },
      allCategories: 'Tất cả phân loại',
      nameRequired: 'Vui lòng nhập tên phân loại',
      nameExists: 'Tên phân loại đã tồn tại',
      queryFailed: 'Truy vấn phân loại thất bại',
      createSuccess: 'Tạo phân loại thành công',
      createFailed: 'Tạo phân loại thất bại',
      deleteSuccess: 'Xóa phân loại thành công',
      deleteFailed: 'Xóa phân loại thất bại'
    }
  },
  emailTasks: {
    title: 'Gửi Email Hàng Loạt',
  
    button: {
      createInternalCampaign: 'Tạo chiến dịch người dùng nội bộ',
      createExternalCampaign: 'Tạo chiến dịch người dùng bên ngoài',
      view: 'Xem',
      edit: 'Sửa',
      delete: 'Xóa',
      sendNow: 'Gửi ngay',
      uploadFile: 'Tải tệp lên',
      importLog: 'Nhật ký nhập danh sách',
      reset: 'Đặt lại'
    },
  
    form: {
      taskName: 'Tên nhiệm vụ',
      taskNamePlaceholder: 'Nhập tên nhiệm vụ',
      operator: 'Người thao tác',
      operatorPlaceholder: 'Nhập người thao tác',
      region: 'Khu vực',
      regionPlaceholder: 'Chọn khu vực',
      status: 'Trạng thái',
      statusPlaceholder: 'Chọn trạng thái',
      sendTime: 'Thời gian gửi',
      mode: 'Chế độ',
      modeFilter: 'Gửi hàng loạt (theo điều kiện)',
      modeImport: 'Nhập tên người dùng (tải CSV)',
      category: 'Phân loại',
      categoryPlaceholder: 'Chọn phân loại',
      template: 'Mẫu email',
      templatePlaceholder: 'Chọn mẫu email',
      agent: 'Tên đại lý',
      agentPlaceholder: 'Chọn đại lý',
      fromEmail: 'Người gửi',
      fromEmailPlaceholder: 'Tự động điền sau khi chọn mẫu',
      templateContent: 'Nội dung mẫu',
      templateContentPlaceholder: 'Tự động điền sau khi chọn mẫu',
      trackStatus: 'Bật theo dõi mở/nhấp',
      uploadEmailList: 'Tải danh sách email lên',
      chooseFile: 'Chọn tệp',
      uploaded: 'Đã tải lên'
    },
  
    table: {
      taskName: 'Tên nhiệm vụ',
      template: 'Mẫu',
      region: 'Khu vực',
      operator: 'Người thao tác',
      createTime: 'Thời gian tạo',
      sendTime: 'Thời gian gửi',
      actions: 'Thao tác'
    },
  
    status: {
      pendingUpload: 'Chờ tải danh sách',
      pendingSend: 'Chờ gửi',
      ready: 'Danh sách sẵn sàng',
      completed: 'Hoàn thành',
      sent: 'Đã gửi'
    },
  
    confirm: {
      delete: 'Bạn có chắc muốn xóa nhiệm vụ này?',
      send: 'Bạn có chắc muốn gửi ngay?'
    },
  
    validation: {
      taskNameRequired: 'Vui lòng nhập tên nhiệm vụ',
      regionRequired: 'Vui lòng chọn khu vực',
      categoryRequired: 'Vui lòng chọn phân loại',
      templateRequired: 'Vui lòng chọn mẫu email',
      agentRequired: 'Vui lòng chọn đại lý'
    },
  
    message: {
      queryFailed: 'Truy vấn thất bại',
      createSuccess: 'Tạo thành công',
      createFailed: 'Tạo thất bại',
      updateSuccess: 'Cập nhật thành công',
      updateFailed: 'Cập nhật thất bại',
      deleteSuccess: 'Xóa thành công',
      deleteFailed: 'Xóa thất bại',
      sendSuccess: 'Gửi thành công',
      sendFailed: 'Gửi thất bại'
    },
  
    upload: {
      success: 'Tải lên thành công',
      failed: 'Tải lên thất bại',
      error: 'Lỗi tải lên: {error}',
      invalidFileType: 'Định dạng tệp không hỗ trợ, vui lòng tải Excel hoặc CSV',
      pleaseUploadFirst: 'Vui lòng tải tệp danh sách lên trước'
    },
  
    modal: {
      createTitle: 'Tạo gửi email hàng loạt',
      editTitle: 'Sửa gửi email hàng loạt',
      viewTitle: 'Xem gửi email hàng loạt',
      importLogTitle: 'Nhật ký nhập danh sách',
      close: 'Đóng'
    },
  
    importLog: {
      result: { excluded: 'Đã loại', failed: 'Thất bại', excludedReason: 'Đã hủy đăng ký, không gửi nữa' },
      loading: 'Đang tải...',
      header: {
        taskName: 'Tên nhiệm vụ',
        operator: 'Người thao tác',
        importFileName: 'Tên tệp nhập',
        importCompleteTime: 'Thời gian hoàn thành nhập',
        importStatus: 'Trạng thái nhập'
      },
      stats: {
        excluded: 'Bị loại do hủy đăng ký',
        success: 'Đã nhập',
        failed: 'Thất bại',
        total: 'Tổng số'
      },
      failureDetails: {
        result: 'Kết quả',
        title: 'Chi tiết thất bại',
        target: 'Người nhận',
        failureReason: 'Lý do thất bại',
        noFailedRecords: 'Không có bản ghi thất bại',
        noImportRecords: 'Chưa có bản ghi nhập'
      },
      uploadFileStatus: {
        '0': 'Đang xử lý',
        '1': 'Hoàn thành',
        '2': 'Thất bại'
      }
    },
  
    pagination: {
      total: 'Tổng {total}'
    }
  },
  emailLogs: {
    title: 'Nhật Ký Gửi Email',
  
    // Form related
    form: {
      sendTime: 'Thời Gian Gửi',
      sendTimePlaceholder: 'Vui lòng chọn thời gian gửi',
      startDate: 'Ngày Bắt Đầu',
      endDate: 'Ngày Kết Thúc',
      region: 'Khu Vực',
      regionPlaceholder: 'Vui lòng chọn khu vực',
      task: 'Tên Nhiệm Vụ',
      taskPlaceholder: 'Vui lòng nhập tên nhiệm vụ',
      subTypePlaceholder: 'Vui lòng chọn loại phụ/loại thành viên',
      subTypeMemberGroup: 'Loại thành viên',
      taskType: 'Loại Gửi',
      taskTypePlaceholder: 'Vui lòng chọn loại gửi',
      bussType: 'Loại Nghiệp Vụ',
      bussTypePlaceholder: 'Vui lòng chọn loại nghiệp vụ',
      account: 'Tài Khoản Thành Viên / Email',
      accountPlaceholder: 'Vui lòng nhập tài khoản thành viên hoặc email',
      status: 'Trạng Thái',
      statusPlaceholder: 'Vui lòng chọn trạng thái'
    },
  
    // Table related
    table: {
      time: 'Thời Gian Gửi',
      task: 'Tên Nhiệm Vụ',
      region: 'Khu Vực',
      type: 'Loại',
      user: 'Tài Khoản Thành Viên',
      email: 'Email',
      status: 'Trạng Thái',
      openTime: 'Đã Mở',
      remark: 'Lý Do Thất Bại'
    },
  
    // Business type
    type: {
      bulk: 'Gửi Hàng Loạt',
      ndc: 'Khách Mới',
      inactive: 'Không Hoạt Động',
      churn: 'Rời Bỏ',
      vip: 'VIP',
      welcome: 'Chào Mừng',
      restorage: 'Nạp Lại'
    },
  
    // Status related
    status: {
      submitted: 'Đã Gửi',
      accepted: 'Đã Gửi',
      delivered: 'Đã Nhận',
      opened: 'Đã Mở',
      failed: 'Thất Bại',
      unsubscribed: 'Đã Hủy Đăng Ký',
      complained: 'Khiếu Nại',
      unknown: 'Không Xác Định'
    },
  
    // Export related
    export: {
      button: 'Xuất',
      loading: 'Tác vụ xuất đã được tạo. Vui lòng kiểm tra tiến trình trong danh sách tải xuống.',
      noData: 'Không có dữ liệu để xuất',
      tooMany: 'Tối đa 100.000 bản ghi mỗi lần xuất. Vui lòng thu hẹp bộ lọc.'
    },
  
    // Message related
    message: {
      queryFailed: 'Truy vấn thất bại',
      exportSuccess: 'Xuất thành công',
      exportFailed: 'Xuất thất bại'
    },
  
    // Pagination related
    pagination: {
      total: 'Tổng cộng {{total}} bản ghi'
    }
  },
  emailReport: {
    // Tiêu đề trang
    title: 'Báo cáo gửi',
    subtitle: 'Báo cáo thống kê và phân tích gửi email',
  
    // Trường biểu mẫu
    form: {
      startTime: 'Thời gian bắt đầu',
      startTimeRequired: 'Vui lòng chọn thời gian bắt đầu',
      startTimePlaceholder: 'Chọn thời gian bắt đầu',
      endTime: 'Thời gian kết thúc',
      endTimeRequired: 'Vui lòng chọn thời gian kết thúc',
      endTimePlaceholder: 'Chọn thời gian kết thúc',
      taskName: 'Tên nhiệm vụ',
      taskNamePlaceholder: 'Nhập tên nhiệm vụ',
      channel: 'Kênh',
      channelPlaceholder: 'Chọn kênh',
      status: 'Trạng thái',
      statusPlaceholder: 'Chọn trạng thái',
      region: 'Khu vực',
      regionPlaceholder: 'Chọn khu vực'
    },
  
    // Trạng thái nhiệm vụ
    status: {
      pending: 'Chờ gửi',
      sending: 'Đang gửi',
      completed: 'Đã hoàn thành'
    },
  
    // Kênh
    channel: {
      mailgunApi: 'Mailgun API'
    },
  
    // Khu vực
    region: {
      ph: 'PH - Philippines',
      vn: 'VN - Việt Nam',
      th: 'TH - Thái Lan',
      cn: 'CN - Trung Quốc'
    },
  
    // Nút
    button: {
      search: 'Tìm kiếm',
      reset: 'Đặt lại',
      export: 'Xuất'
    },
  
    // Cột bảng
    table: {
      date: 'Ngày',
      task: 'Tên Nhiệm Vụ',
      targetCount: 'Mục tiêu',
      sendCount: 'Đã gửi',
      deliveredCount: 'Thành công',
      failedCount: 'Thất bại',
      openedCount: 'Đã mở',
      actions: 'Thao tác',
      viewLogs: 'Xem nhật ký'
    },
  
    // Hộp thoại nhật ký
    logs: {
      title: 'Nhật ký gửi',
      time: 'Thời gian',
      task: 'Nhiệm vụ',
      user: 'Người dùng',
      email: 'Email',
      channel: 'Kênh',
      status: 'Trạng thái',
      remark: 'Ghi chú',
      statusPending: 'Chờ gửi',
      statusSuccess: 'Thành công',
      statusFailed: 'Thất bại',
      statusUnknown: 'Không xác định'
    },
  
    // Thông báo
    message: {
      selectTimeRange: 'Vui lòng chọn thời gian bắt đầu và kết thúc',
      exportSuccess: 'Xuất thành công',
      exportFailed: 'Xuất thất bại',
      exporting: 'Đang xuất dữ liệu...',
      queryFailed: 'Truy vấn thất bại',
      noData: 'Không có dữ liệu'
    },
  
    // Phân trang
    pagination: {
      total: 'Tổng {total} bản ghi'
    }
  },
  emailUnsubscribe: {
    title: 'Danh sách hủy đăng ký',
  
    // Biểu mẫu / bộ lọc
    form: {
      unsubscribeTime: 'Thời gian hủy đăng ký',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      emailAddress: 'Địa chỉ email',
      emailAddressPlaceholder: 'Vui lòng nhập địa chỉ email',
      memberAccount: 'Tài khoản thành viên',
      memberAccountPlaceholder: 'Vui lòng nhập tài khoản thành viên',
      originType: 'Nguồn',
      originTypePlaceholder: 'Vui lòng chọn nguồn',
      reason: 'Lý do',
      reasonPlaceholder: 'Vui lòng chọn lý do',
      remark: 'Ghi chú',
      remarkPlaceholder: 'Vui lòng nhập ghi chú',
      search: 'Tìm kiếm',
      reset: 'Đặt lại'
    },
  
    // Bảng
    table: {
      nonMember: 'Không phải hội viên',
      unsubscribeTime: 'Thời gian hủy đăng ký',
      emailAddress: 'Địa chỉ email',
      memberAccount: 'Tài khoản thành viên',
      originType: 'Nguồn',
      remark: 'Ghi chú',
      actions: 'Thao tác'
    },
  
    // Loại nguồn
    originType: {
      all: 'Tất cả',
      selfUnsubscribe: 'Tự hủy đăng ký (Liên kết)',
      complaint: 'Khiếu nại / Yêu cầu',
      manual: 'CSKH thêm thủ công'
    },
  
    // Hộp thoại thêm mới
    add: {
      mode: 'Hủy đăng ký theo',
      modeMember: 'Tài khoản hội viên',
      modeEmail: 'Địa chỉ email',
      modeEmailHint: 'Dùng cho ngưới không phải hội viên / khiếu nại',
      lookupEmail: 'Tra email',
      validEmail: 'Email đã xác minh (tự động, ẩn một phần, chỉ đọc)',
      validEmailPlaceholder: 'Tự động hiển thị sau khi tra tài khoản',
      button: 'Thêm hủy đăng ký',
      title: 'Thêm hủy đăng ký',
      okText: 'Xác nhận',
      cancelText: 'Hủy'
    },
  
    // Xóa
    delete: {
      button: 'Xóa',
      confirm: 'Bạn có chắc chắn muốn xóa bản ghi hủy đăng ký này không?',
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      complaintBlocked: 'Bản ghi hủy đăng ký do khiếu nại / yêu cầu không thể xóa. Chỉ có thể xóa các bản ghi do CSKH thêm thủ công.'
    },
  
    // Xác thực
    validation: {
      memberAccountRequired: 'Vui lòng nhập tài khoản hội viên',
      lookupFirst: 'Vui lòng bấm Tra email để xác nhận email đã xác minh',
      emailAddressRequired: 'Vui lòng nhập địa chỉ email',
      emailAddressInvalid: 'Vui lòng nhập địa chỉ email hợp lệ',
      reasonRequired: 'Vui lòng chọn lý do'
    },
  
    // Thông báo
    message: {
      lookupFailed: 'Tra email hội viên thất bại',
      queryFailed: 'Truy vấn thất bại',
      addSuccess: 'Thêm thành công',
      addFailed: 'Thêm thất bại',
      deleteSuccess: 'Xóa thành công',
      deleteFailed: 'Xóa thất bại'
    }
  },
  emailAutoPushConfig: {
    title: 'Cấu hình email tự động',

    searchForm: {
      language: 'Ngôn ngữ',
      languagePlaceholder: 'Vui lòng chọn ngôn ngữ',
      bussType: 'Loại nghiệp vụ',
      bussTypePlaceholder: 'Vui lòng chọn loại nghiệp vụ',
      aimType: 'Loại mục tiêu',
      aimTypePlaceholder: 'Vui lòng chọn loại mục tiêu',
      subPushType: 'Loại phụ',
      subPushTypePlaceholder: 'Vui lòng chọn loại phụ',
      memberType: 'Loại thành viên',
      memberTypePlaceholder: 'Vui lòng chọn loại thành viên',
      status: 'Trạng thái',
      statusPlaceholder: 'Vui lòng chọn trạng thái',
      search: 'Tìm kiếm',
      reset: 'Đặt lại',
      add: 'Thêm quy tắc'
    },

    table: {
      language: 'Ngôn ngữ',
      aimType: 'Loại mục tiêu',
      subTypeOrMember: 'Loại phụ/Loại thành viên',
      ruleName: 'Tên quy tắc',
      template: 'Mẫu',
      status: 'Trạng thái',
      operation: 'Thao tác',
      edit: 'Sửa'
    },

    aimType: {
      scene: 'Kích hoạt theo kịch bản',
      target: 'Người dùng mục tiêu'
    },

    pushSwitch: {
      enabled: 'Bật',
      disabled: 'Tắt'
    },

    confirm: {
      enable: 'Bạn có chắc chắn muốn bật quy tắc này không?',
      disable: 'Bạn có chắc chắn muốn tắt quy tắc này không?',
      okText: 'Xác nhận',
      cancelText: 'Hủy'
    },

    modal: {
      addTitle: 'Thêm quy tắc email tự động',
      editTitle: 'Sửa quy tắc email tự động',
      baseInfoTitle: 'Thông tin cơ bản',
      ruleName: 'Tên quy tắc',
      ruleNamePlaceholder: 'Vui lòng nhập tên quy tắc',
      language: 'Ngôn ngữ',
      languagePlaceholder: 'Vui lòng chọn ngôn ngữ',
      aimType: 'Loại mục tiêu',
      pushType: 'Sự kiện kích hoạt',
      pushTypePlaceholder: 'Vui lòng chọn sự kiện kích hoạt',
      subPushType: 'Loại phụ',
      subPushTypePlaceholder: 'Vui lòng chọn loại phụ',
      loginChannel: 'Kênh đăng nhập',
      loginChannelPlaceholder: 'Vui lòng chọn kênh đăng nhập',
      memberType: 'Loại thành viên',
      memberTypePlaceholder: 'Vui lòng chọn loại thành viên',
      sendTime: 'Thời gian gửi',
      sendTimePlaceholder: 'Vui lòng nhập thời gian gửi',
      sendTimePlaceholderDay: 'Vui lòng nhập số ngày',
      sendTimePlaceholderWeek: 'Vui lòng nhập 1-7 (1=Thứ Hai, 7=Chủ Nhật)',
      sendTimePlaceholderMonth: 'Vui lòng nhập 1-31 (ngày trong tháng)',
      sendTimeUnit: 'Đơn vị thời gian',
      status: 'Trạng thái',
      enable: 'Bật',
      disable: 'Tắt',
      emailContentTitle: 'Nội dung email',
      bussType: 'Loại nghiệp vụ',
      bussTypePlaceholder: 'Vui lòng chọn loại nghiệp vụ',
      tempClassify: 'Danh mục mẫu',
      tempClassifyPlaceholder: 'Vui lòng chọn danh mục mẫu',
      template: 'Chọn mẫu',
      templatePlaceholder: 'Vui lòng chọn mẫu',
      preview: {
        fromEmail: 'Người gửi',
        tempTitle: 'Tiêu đề email',
        tempContent: 'Nội dung email'
      }
    },

    validation: {
      ruleNameRequired: 'Vui lòng nhập tên quy tắc',
      languageRequired: 'Vui lòng chọn ngôn ngữ',
      subPushTypeRequired: 'Vui lòng chọn loại phụ',
      sendTimeRequired: 'Vui lòng nhập thời gian gửi',
      sendTimeUnitRequired: 'Vui lòng chọn đơn vị thời gian',
      sendTimeRange: 'Thời gian gửi phải nằm trong khoảng {{min}}-{{max}}',
      tempClassifyRequired: 'Vui lòng chọn danh mục mẫu',
      templateRequired: 'Vui lòng chọn mẫu',
      depositNumberRequired: 'Vui lòng nhập thứ tự nạp tiền'
    },

    messages: {
      fetchDataFailed: 'Lấy dữ liệu thất bại',
      addSuccess: 'Thêm thành công',
      addFailed: 'Thêm thất bại',
      updateSuccess: 'Cập nhật thành công',
      updateFailed: 'Cập nhật thất bại',
      confirmDelete: 'Xác nhận xóa',
      deleteSuccess: 'Xóa thành công',
      deleteFailed: 'Xóa thất bại',
      statusUpdateSuccess: 'Cập nhật trạng thái thành công',
      statusUpdateFailed: 'Cập nhật trạng thái thất bại'
    }
  },
  // 发信域名 / 渠道（FBMPLAY-1595 多域名多 Key，发件人管理页 Admin-only Tab）
  emailChannels: {
    title: 'Tên miền gửi / Kênh',

    tab: {
      channels: 'Tên miền gửi',
    },

    hint: {
      perDomainKey: 'Mỗi tên miền một Sending API Key (hỗ trợ nhiều key); ngưới gửi thuộc tên miền và dùng chung key.'
    },

    table: {
      sendDomain: 'Tên miền gửi',
      region: 'Region',
      apiKey: 'Sending API Key',
      apiKeyMissing: 'Chưa cấu hình',
      status: 'Trạng thái',
      lastOperator: 'Ngưới thao tác cuối / thời gian',
      actions: 'Thao tác'
    },

    form: {
      sendDomain: 'Tên miền gửi',
      sendDomainPlaceholder: 'VD: mail.newbrand.com',
      region: 'Region',
      apiKey: 'Sending API Key',
      apiKeyPlaceholder: 'Dán Mailgun sending API key của tên miền này',
      apiKeyHint: 'Chỉ ghi, không hiển thị lại; sau khi lưu chỉ thấy 4 ký tự cuối',
      apiKeyEditHint: 'Để trống = giữ key hiện tại (key-••••••••{{tail}}); nhập vào = thay key',
      status: 'Trạng thái'
    },

    status: {
      enabled: 'Bật',
      disabled: 'Tắt'
    },

    button: {
      create: 'Thêm tên miền',
      edit: 'Sửa',
      delete: 'Xóa',
      replaceKey: 'Thay key',
      testConnection: 'Kiểm tra kết nối',
      testing: 'Đang kiểm tra...',
      save: 'Lưu',
      cancel: 'Hủy'
    },

    modal: {
      createTitle: 'Thêm tên miền gửi',
      editTitle: 'Sửa tên miền gửi',
      replaceKeyTitle: 'Thay Sending API Key'
    },

    validation: {
      sendDomainRequired: 'Vui lòng nhập tên miền gửi',
      sendDomainInvalid: 'Vui lòng nhập tên miền hợp lệ, VD mail.newbrand.com',
      regionRequired: 'Vui lòng chọn region',
      apiKeyRequired: 'Vui lòng nhập Sending API Key'
    },

    confirm: {
      delete: 'Xóa tên miền gửi này?',
      enable: 'Bật tên miền gửi này?',
      disable: 'Tắt tên miền gửi này? Ngưới gửi thuộc tên miền sẽ không gửi được.',
      okText: 'Đồng ý',
      cancelText: 'Hủy'
    },

    message: {
      queryFailed: 'Truy vấn thất bại',
      createSuccess: 'Thêm thành công',
      createFailed: 'Thêm thất bại',
      updateSuccess: 'Cập nhật thành công',
      updateFailed: 'Cập nhật thất bại',
      deleteSuccess: 'Xóa thành công',
      deleteFailed: 'Xóa thất bại',
      statusUpdateSuccess: 'Cập nhật trạng thái thành công',
      statusUpdateFailed: 'Cập nhật trạng thái thất bại',
      testSuccess: 'Kết nối thành công (backend kiểm tra, key không trả về frontend)',
      testFailed: 'Kết nối thất bại, vui lòng kiểm tra tên miền, region và API key'
    }
  },
};
